import React from "react";
import i18n from "@/i18n";
import { Button } from "./ui/button";
import { Eye, EyeClosed, SignalHigh, SignalMedium } from "lucide-react";
import { Badge } from "./ui/badge";

const { t } = i18n;

export const MASKING_LEVELS = ["none", "low", "high", "full"];

export const EXAMPLE_SSN_MASKING_BY_COUNTRY = {
  se: {
    none: "19901224-1234",
    low: "19901224-XXXX",
    high: "1990XXXX-XXXX",
    full: "XXXXXXXX-XXXX",
  },
};

export const MaskLevelIcon = (props) => {
  const { level } = props;

  const icon = {
    none: Eye,
    low: SignalMedium,
    high: SignalHigh,
    full: EyeClosed,
  }[level];

  return React.createElement(icon, props);
};

export const MaskLevelBadge = ({ level, title }) => {
  const icon = <MaskLevelIcon level={level} size={16} />;

  return (
    <Badge
      variant="background"
      size="sm"
      className="flex items-center gap-1 px-4 font-bold"
      title={<div className="max-w-[250px] text-center">{title}</div>}
    >
      {icon} {t(`ssn_masking.values.${level}`)}
    </Badge>
  );
};

const MaskSsnField = ({ country = "se", value = "none", onChange }) => {
  if (!MASKING_LEVELS.includes(value)) {
    throw new Error(`Invalid SSN masking level: ${value}`);
  }

  const exampleSsn = EXAMPLE_SSN_MASKING_BY_COUNTRY[country][value];

  return (
    <div className="flex justify-between">
      <div className="flex gap-2">
        {MASKING_LEVELS.map((level) => (
          <Button
            variant={value === level ? "default" : "outline-primary"}
            key={level}
            onClick={() => onChange(level)}
          >
            <MaskLevelIcon size={16} level={level} />
            {t(`ssn_masking.values.${level}`)}
          </Button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        {t("generic.example")}:{" "}
        <span className="font-mono text-lg font-bold">{exampleSsn}</span>
      </div>
    </div>
  );
};

export default MaskSsnField;
